/* Minuteur d'offre des sections (bloc de thème nky-minuteur, 31/10/2026) : même calcul que celui de la zone d'achat
   (nky-achat.js). Chargé par chaque minuteur : ne s'installe qu'une fois ; si nky-achat.js est aussi sur la page, les deux
   écrivent les mêmes chiffres, sans conflit. */
(function () {
  if (window.nkyMinuteurSection) return;
  window.nkyMinuteurSection = true;
  function parisVersMs(txt) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/.exec((txt || '').trim());
    if (!m) return NaN;
    var essai = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59));
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(essai)).forEach(function (x) { p[x.type] = x.value; });
      var vuAParis = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
      return essai - (vuAParis - essai);
    } catch (e) { return essai - 3600000; }
  }
  function echeance(el) {
    if (el.dataset.mode === 'minuit') { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
    return parisVersMs(el.dataset.fin);
  }
  var deux = function (n) { return (n < 10 ? '0' : '') + n; };
  function tic() {
    document.querySelectorAll('[data-nky-minuteur]').forEach(function (el) {
      var reste = echeance(el) - Date.now();
      if (!(reste > 0)) {
        if (el.hasAttribute('data-editeur')) { el.hidden = false; reste = 0; } else { el.hidden = true; return; }
      }
      el.hidden = false;
      var s = Math.floor(reste / 1000), h = Math.floor(s / 3600);
      el.querySelector('[data-h]').textContent = deux(h);
      el.querySelector('[data-m]').textContent = deux(Math.floor(s % 3600 / 60));
      el.querySelector('[data-s]').textContent = deux(s % 60);
    });
  }
  tic(); setInterval(tic, 1000);
  document.addEventListener('shopify:section:load', tic);
})();
